// import { Injectable, Injector } from '@angular/core';
// import {
//   HttpRequest,
//   HttpHandler,
//   HttpEvent,
//   HttpInterceptor,
//   HttpErrorResponse,
// } from '@angular/common/http';
// import { Observable, throwError } from 'rxjs';
// import { AuthService } from './auth.service';
// import { catchError } from 'rxjs/operators';

// @Injectable()
// export class JwtInterceptor implements HttpInterceptor {
//   private _router;
//   constructor(private authenticationService: AuthService, inj: Injector) {
//     this._router = inj.get(AuthService);
//   }

//   intercept(
//     request: HttpRequest<any>,
//     next: HttpHandler,
//   ): Observable<HttpEvent<any>> {
//     // add auth header with jwt if user is logged in and request is to the api url
//     const currentUser = this.authenticationService.currentUserTokenValue;

//     const isLoggedIn = currentUser && currentUser.token;

//     if (isLoggedIn) {
//       request = request.clone({
//         setHeaders: {
//           Authorization: `Bearer ${currentUser.token}`,
//         },
//       });
//     }

//     return next.handle(request).pipe(
//       catchError((error) => {
//         if (error instanceof HttpErrorResponse && error.status === 401) {
//           this._router.logout();
//           return throwError(error);
//         } else {
//           return throwError(error);
//         }
//       }),
//     );
//   }
// }


import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, BehaviorSubject, throwError } from 'rxjs';
import { catchError, filter, switchMap, take, tap } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<string | null> =
    new BehaviorSubject<string | null>(null);

  constructor(private authService: AuthService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const currentUser = this.authService.currentUserTokenValue;
    const isLoggedIn = currentUser && currentUser.token;
    const isRefreshUrl = request.url.includes('/auth/local/refresh');
    const isLogoutUrl = request.url.includes('/auth/local/logout');
    const isLoginUrl =
      request.url.includes('/auth/local/') &&
      !isRefreshUrl &&
      !isLogoutUrl;
    const isCookieAuthUrl = isLoginUrl || isLogoutUrl || isRefreshUrl;

    const cloneOptions: {
      withCredentials?: boolean;
      setHeaders?: { Authorization: string };
    } = {};

    if (isLoggedIn) {
      cloneOptions.setHeaders = {
        Authorization: `Bearer ${currentUser.token}`,
      };
    }

    if (isCookieAuthUrl) {
      cloneOptions.withCredentials = true;
    }

    if (cloneOptions.setHeaders || cloneOptions.withCredentials) {
      request = request.clone(cloneOptions);
    }

    return next.handle(request).pipe(
      catchError((error) => {
        if (
          error instanceof HttpErrorResponse &&
          error.status === 401 &&
          !isCookieAuthUrl
        ) {
          return this.handle401Error(request, next);
        }
        return throwError(() => error);
      })
    );
  }

  private handle401Error(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);

      // Use the HttpOnly cookie refresh token
      return this.authService.refreshToken().pipe(
        tap((response) => {
          const newToken = response?.token || response?.accessToken;
          if (newToken) {
            this.authService.setToken(newToken);
            this.refreshTokenSubject.next(newToken);
          }
        }),
        switchMap(() => {
          const newToken = this.authService.currentUserTokenValue?.token;
          const cloned = request.clone({
            setHeaders: {
              Authorization: `Bearer ${newToken}`,
            },
          });
          return next.handle(cloned);
        }),
        catchError((err) => {
          this.authService.logout();
          return throwError(() => err);
        }),
        tap({
          next: () => {
            this.isRefreshing = false;
          },
          error: () => {
            this.isRefreshing = false;
          },
        })
      );
    } else {
      // Wait for ongoing refresh
      return this.refreshTokenSubject.pipe(
        filter((token) => token != null),
        take(1),
        switchMap((token) => {
          const cloned = request.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`,
            },
          });
          return next.handle(cloned);
        })
      );
    }
  }
}
